import styled from 'styled-components';
import {
  HUB_SIDEBAR_MOBILE_BREAKPOINT,
  HUB_SIDEBAR_WIDTH_COLLAPSED,
  HUB_SIDEBAR_WIDTH_OPEN,
} from '../../../constants/breakpoints';

export const transition = '0.3s';

export interface BodyWrapperProps {
  isSideOpen: boolean;
  isFormPage?: boolean;
}

export const BodyWrapper = styled.div<BodyWrapperProps>`
  transition: margin-left ${transition} ease;
  font-weight: 400;
  line-height: 1.5;
  text-align: left;
  font-size: 14px;
  box-shadow: 1px 3px 25px rgba(0, 0, 0, 0.07);
  background-color: ${({isFormPage, theme }) => (isFormPage ? theme.colors.white : theme.colors.background)};
  margin-left: ${(props) =>
    props.isSideOpen ? HUB_SIDEBAR_WIDTH_OPEN : HUB_SIDEBAR_WIDTH_COLLAPSED};
  margin-top: 0;
  min-width: 0;
`;

export const Body = styled.div`
  min-height: calc(100vh - ${({ theme }) => theme.header.size});
  position: relative;
  padding: 48px 32px;
  padding-top: calc(48px + ${({ theme }) => theme.header.size});
  color: ${({ theme }) => theme.body.color};

  @media screen and (max-width: ${HUB_SIDEBAR_MOBILE_BREAKPOINT}) {
    padding: 24px 16px;
    padding-top: calc(24px + ${({ theme }) => theme.header.size});
  }
`;
